export default __webpack_public_path__ + "static/mainfeatureai3-4af7ad2c7f58835a8ffbf73014ce83b2.svg";